import React, { useEffect, useState } from "react";
import {
  getTeamMembers,
  getAllProperties,
  filterArrayWithQuery,
  getBankBranchByIfsc,
  getBankByUuid,
  createAuctionEvent,
  updateAuctionEvent,
  amountInWords,
  convertAmmountToWords,
} from "services";
import {
  BetaForm as useBetaForm,
  ButtonBase,
  TextInputBase,
  ModalBase,
  PickerSelectSimple,
  TextAreaBase,
} from "@reusejs/react";
import { useSelector } from "react-redux";
import SuccessFailureModal from "./SuccessFailureModal";
import Loader from "../../../layouts/Loader";
import { useRouter } from "next/router";
import { DateTime } from "luxon";

export interface EventFormPorps {
  mode?: string;
  prefillData?: any;
}

export default function EventForm(props: EventFormPorps) {
  const router = useRouter();
  const userProfile = useSelector((state: any) => {
    return state.bankerAuth.user;
  });

  const currentBranch = useSelector((state: any) => {
    return state.bankerAuth.currentBranch;
  });

  const bank = useSelector((state: any) => {
    return state.bankerAuth.bank;
  });

  //   console.log(userProfile, currentBranch, bank);

  const form = useBetaForm({
    property_uuid: "",
    created_by: userProfile.uuid ? userProfile.uuid : "",
    event_name: "",
    event_type: "",
    assigned_ao: "",
    signature_type: "",
    kyc_type: "",
    auction_type: { label: "Forward", value: "Forward" },
    auction_currency: { label: "INR", value: "INR" },
    possession_type: "",
    auto_extension: { label: "Yes", value: "Yes" },
    auto_extension_type: "",
    auto_extension_limit: "",
    extension_method: "",
    extend_time_at: "",
    extend_time_by: "",
    bidding_increment_amount: "",
    borrower_name: "",
    emd_payment_account_name: "",
    emd_payment_account_number: "",
    emd_payment_account_ifsc: "",
    emd_payment_account_bank: "",
    emd_payment_account_branch: "",
    emd_payment_method: "",
    comment: "",
    approver: "",
    bidding_type: "",
  });

  const form_constraints = {
    event_name: {
      presence: {
        allowEmpty: false,
      },
    },
    emd_payment_account_number: {
      length: {
        maximum: 25,
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  const biddingTypeValues: any = {
    rp: "With Reserve Price",
    ib: "With Increment Price",
  };

  useEffect(() => {
    if ((props.mode === "edit" || props.mode === "view") && props.prefillData) {
      prefillFormValues(props.prefillData);
    }
  }, [props.mode, props.prefillData, currentBranch]);

  const prefillFormValues = async (data: any) => {
    form.setField("event_name", data.event_name);
    form.setField("event_type", {
      label: data.event_type,
      value: data.event_type,
    });
    form.setField("signature_type", {
      label: data.signature_type,
      value: data.signature_type,
    });
    form.setField("kyc_type", {
      label: data.kyc_type,
      value: data.kyc_type,
    });
    form.setField("auction_type", {
      label: data.auction_type,
      value: data.auction_type,
    });
    form.setField("auction_currency", {
      label: data.auction_currency,
      value: data.auction_currency,
    });
    form.setField("possession_type", {
      label: data.possession_type,
      value: data.possession_type,
    });

    form.setField("auto_extension", {
      label: data.auto_extension,
      value: data.auto_extension,
    });
    form.setField("extension_method", {
      label: data.extension_method,
      value: data.extension_method,
    });
    form.setField("auto_extension_type", {
      label: data.auto_extension_type,
      value: data.auto_extension_type,
    });

    form.setField("auto_extension_limit", data.auto_extension_limit);

    form.setField("extend_time_at", {
      label: data.extend_time_at + " Minutes",
      value: data.extend_time_at,
    });

    form.setField("extend_time_by", {
      label: data.extend_time_by + " Minutes",
      value: data.extend_time_by,
    });
    form.setField("bidding_increment_amount", data.bidding_increment_amount);
    form.setField("borrower_name", data.borrower_name);
    form.setField("emd_payment_account_name", data.emd_payment_account_name);
    form.setField(
      "emd_payment_account_number",
      data.emd_payment_account_number,
    );
    form.setField("emd_payment_account_ifsc", data.emd_payment_account_ifsc);
    form.setField("emd_payment_account_bank", data.emd_payment_account_bank);
    form.setField(
      "emd_payment_account_branch",
      data.emd_payment_account_branch,
    );
    form.setField("emd_payment_method", {
      label: data.emd_payment_method,
      value: data.emd_payment_method,
    });

    form.setField("bidding_type", {
      label: biddingTypeValues[data.bidding_type],
      value: data.bidding_type,
    });

    form.setField("comment", data.comment);
    const propertyData: any = await getPropertiesData("");
    if (propertyData) {
      propertyData.map((item: any) => {
        if (item.value === data.property_uuid) {
          form.setField("property_uuid", item);
        }
      });
    }

    const teamsMembersData: any = await getMembersFilteredData();

    teamsMembersData.ao.map((item: any) => {
      if (item.value === data.assigned_ao) {
        form.setField("assigned_ao", item);
      }
    });

    teamsMembersData.so.map((item: any) => {
      if (item.value === data.approver) {
        form.setField("approver", item);
      }
    });
  };

  const openModal = async (
    type: string,
    title: string,
    message: string,
    color: string,
    eventData: any,
  ) => {
    const SuccessModalWrapper = (props: any) => {
      return (
        <SuccessFailureModal
          router={router}
          type={type}
          heading={title}
          description={message}
          eventData={eventData}
          callback={(remark: string) => handleRejection(remark)}
          color={color}
          {...props}
        />
      );
    };

    await ModalBase(
      {
        content: SuccessModalWrapper,
        timeout: 0,
        backgroundColor: "bg-black/30",
        backgroundOpacity: "opacity-70",
        modalBaseClasses: {
          background: "bg-white",
          border: "border-2 rounded-lg",
          alignment: "z-50  overflow-visible",
          padding: "p-0",
          small: "max-w-4xl",
        },
      },
      1000,
      "__next",
    );
  };

  const handleSubmit = async () => {
    try {
      if (form.validate()) {
        form.startProcessing();
        if (props.mode === "edit") {
          const data: any = await updateAuctionEvent(
            form.value,
            props.prefillData,
            "pending",
            "",
          );
          console.log("data::>", data);
          if (data) {
            openModal(
              "edit",
              "Auction Event Updated",
              "Auction event has been updated successfully. Please add bidders.",
              "bg-green-50 text-green-500",
              data,
            );
          }
          form.finishProcessing();
        } else {
          const data: any = await createAuctionEvent(form.value);
          if (data) {
            openModal(
              "edit",
              "Auction Event Created",
              "Auction event has been created successfully. Please add bidders.",
              "bg-green-50 text-green-500",
              data,
            );
          }
          form.finishProcessing();
        }
      }
    } catch (error: any) {
      form.finishProcessing();
      console.log("check here error", error);
      if (error?.response?.data?.errors) {
        form.setErrors(error.response.data.errors);
      }
    }
  };

  const getMembersFilteredData = async () => {
    const response: any = await getTeamMembers(
      currentBranch.team["teams*uuid"],
    );
    const data: any = response.data;
    const supervisorOfficers =
      data.length > 0 &&
      data.filter((item: any) => item["permissions"].role === "approver");

    const authorizedOfficers =
      data.length > 0 &&
      data.filter((item: any) => item["permissions"].role === "member");

    const filteredAoData = authorizedOfficers.map((item: any) => {
      return {
        value: item["user_uuid"],
        label: item["attributes"][0]?.value
          ? item["attributes"][0]?.value
          : "NA",
        profile: item["user"]["profile"],
      };
    });

    const filteredSoData = supervisorOfficers.map((item: any) => {
      return {
        value: item["user_uuid"],
        label: item["user"]?.profile?.bio?.full_name
          ? item["user"]?.profile?.bio?.full_name
          : item["attributes"][0]?.value
          ? item["attributes"][0]?.value
          : "NA",
        email: item["attributes"][0]?.value
          ? item["attributes"][0]?.value
          : "NA",
        profile: item["user"]["profile"],
      };
    });

    return { ao: filteredAoData, so: filteredSoData };
  };

  const getTeamsData = async () => {
    const data = await getMembersFilteredData();
    const assignedAo = data.ao.filter(
      (item: any) => item.value === userProfile.uuid,
    );
    form.setField("assigned_ao", assignedAo[0]);

    return data.so;
  };

  const getPropertiesData = async (query: any) => {
    const data: any = await getAllProperties({
      apiConfig: {
        includeRelations: ["city", "sub_asset_type", "bank", "branch"],
        includeMutations: ["state", "asset"],
        includeFacets: false,
      },
      limitBy: {
        per_page: 999,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [
        // enable it once testing is done
        // {
        //   attribute: "status",
        //   op: "eq",
        //   value: "active",
        // },
        {
          attribute: "branch_uuid",
          op: "eq",
          value: currentBranch.value,
        },
      ],
    });

    let filteredData =
      data.data.length > 0 &&
      data.data.map((item: any) => {
        return {
          value: item.uuid,
          label: item.property_id,
          property:
            props.prefillData && props.prefillData?.status === "end"
              ? props.prefillData.property_dump
              : item,
        };
      });

    if (query && query !== "") {
      filteredData = filterArrayWithQuery(filteredData, query);
    }
    return filteredData;
  };

  const handleIFSCCode = async (value: any) => {
    form.setField("emd_payment_account_ifsc", value);
    if (value.length > 6) {
      const data: any = await getBankBranchByIfsc(value);
      if (data) {
        form.setField("emd_payment_account_branch", data.name);
        const bankData: any = await getBankByUuid(data.bank_uuid);
        if (bankData) {
          form.setField("emd_payment_account_bank", bankData.name);
        }
      } else {
        form.setField("emd_payment_account_branch", "");
        form.setField("emd_payment_account_bank", "");
      }
    }
  };

  const handleRejection = async (remark: string) => {
    try {
      const data: any = await updateAuctionEvent(
        form.value,
        props.prefillData,
        "rejected",
        remark,
      );
      if (data) {
        openModal(
          "edit",
          "Auction Event Rejected",
          "You have rejected the auction event.",
          "bg-red-50 text-red-500",
          data,
        );
      }
    } catch (error: any) {
      console.log("check here error", error);
    }
  };

  const handleApproval = async () => {
    try {
      const data: any = await updateAuctionEvent(
        form.value,
        props.prefillData,
        "accepted",
        "",
      );
      if (data) {
        openModal(
          "edit",
          "Auction Event Approved",
          "You have successfully approved the Auction event.",
          "bg-green-50 text-green-500",
          data,
        );
      }
    } catch (error: any) {
      console.log("check here error", error);
    }
  };

  return (
    <div className="sm: grid sm:grid-cols-2 gap-8">
      <div className="col-span-2 border-b border-gray-400 font-semibold pb-2 pt-8">
        Event Details
      </div>
      <div className="col-span-2">
        <TextAreaBase
          name={"event_name"}
          labelBaseProps={{
            label: "Event Name",
          }}
          rows={2}
          onChange={(val) => {
            form.setField("event_name", val);
          }}
          placeholder={"Enter event name"}
          error={
            form.errors.get("event_name") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("event_name")[0]}
              </p>
            ) : null
          }
          value={form.getField("event_name")}
          disabled={props.mode === "view"}
        />
        {/* <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Event Name",
          }}
          name={"event_name"}
          onChange={(val) => {
            form.setField("event_name", val);
          }}
          placeholder={"Enter event name"}
          type={"text"}
          error={
            form.errors.get("event_name") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("event_name")[0]}
              </p>
            ) : null
          }
          value={form.getField("event_name")}
          htmlFor={"event_name"}
          disabled={props.mode === "view"}
        /> */}
      </div>
      <div>
        <PickerSelectSimple
          dataSource={async (c) => {
            return await getTeamsData();
          }}
          defaultSelected={
            form.getField("approver") !== "" ? [form.getField("approver")] : []
          }
          labelBaseProps={{
            label: "Approver",
          }}
          onChange={(value: any) => form.setField("approver", value)}
          error={
            form.errors.get("approver") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("approver")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableClear={false}
          enableClose={false}
          enableSearch={false}
          disabled={props.mode === "view"}
        />
        {/* <PickerSelectSimple
          dataSource={async (c) => {
            return await getTeamsData();
          }}
          defaultSelected={
            form.getField("assigned_ao") !== ""
              ? [form.getField("assigned_ao")]
              : []
          }
          labelBaseProps={{
            label: "AO Email",
          }}
          onChange={(value: any) => form.setField("assigned_ao", value)}
          error={
            form.errors.get("assigned_ao") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("assigned_ao")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableClear={false}
          enableClose={false}
          enableSearch={false}
          disabled={props.mode === "view"}
        /> */}
      </div>
      {/* <div>
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Contact Number",
          }}
          name={"ao_contact"}
          onChange={(val) => {}}
          placeholder={"Enter contact number"}
          type={"text"}
          value={form.value.assigned_ao.profile?.bio?.mobile_number}
          disabled={true}
          htmlFor={"ao_contact"}
        />
      </div> */}
      {/* <div>
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "AO Email",
          }}
          name={"ao_email"}
          onChange={(val) => {}}
          placeholder={"Enter email"}
          type={"text"}
          value={form.value.assigned_ao.label}
          disabled={true}
          htmlFor={"ao_email"}
        />
      </div> */}
      <div>
        <PickerSelectSimple
          dataSource={async (c) => {
            return [
              { label: "Sarfaesi", value: "Sarfaesi" },
              { label: "DRT", value: "DRT" },
              { label: "Private", value: "Private" },
              { label: "IBC", value: "IBC" },
              { label: "Asset transfer", value: "Asset transfer" },
            ];
          }}
          defaultSelected={
            form.getField("event_type") !== ""
              ? [form.getField("event_type")]
              : []
          }
          labelBaseProps={{
            label: "Event Type",
          }}
          onChange={(value: any) => form.setField("event_type", value)}
          error={
            form.errors.get("event_type") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("event_type")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableClear={false}
          enableClose={false}
          enableSearch={false}
          disabled={props.mode === "view"}
        />
      </div>
      <div>
        <PickerSelectSimple
          dataSource={async (c) => {
            return [
              { label: "DSC", value: "DSC" },
              { label: "Aadhaar OTP", value: "Aadhaar OTP" },
              {
                label: "Inked Physical form to be sent to Bank",
                value: "Inked Physical form to be sent to Bank",
              },
            ];
          }}
          defaultSelected={
            form.getField("signature_type") !== ""
              ? [form.getField("signature_type")]
              : []
          }
          labelBaseProps={{
            label: "Signature Type",
          }}
          onChange={(value: any) => form.setField("signature_type", value)}
          error={
            form.errors.get("signature_type") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("signature_type")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableClear={false}
          enableClose={false}
          enableSearch={false}
          disabled={props.mode === "view"}
        />
      </div>
      <div>
        <PickerSelectSimple
          dataSource={async (c) => {
            return [{ label: "Forward", value: "Forward" }];
          }}
          defaultSelected={
            form.getField("auction_type") !== ""
              ? [form.getField("auction_type")]
              : [{ label: "Forward", value: "Forward" }]
          }
          labelBaseProps={{
            label: "Auction Type",
          }}
          onChange={(value: any) => form.setField("auction_type", value)}
          error={
            form.errors.get("auction_type") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("auction_type")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableClear={false}
          enableClose={false}
          enableSearch={false}
          disabled={props.mode === "view"}
        />
      </div>
      <div>
        <PickerSelectSimple
          dataSource={async (c) => {
            return [{ label: "INR", value: "INR" }];
          }}
          defaultSelected={
            form.getField("auction_currency") !== ""
              ? [form.getField("auction_currency")]
              : [{ label: "INR", value: "INR" }]
          }
          labelBaseProps={{
            label: "Auction Currency",
          }}
          onChange={(value: any) => form.setField("auction_currency", value)}
          error={
            form.errors.get("auction_currency") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("auction_currency")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableClear={false}
          enableClose={false}
          enableSearch={false}
          disabled={props.mode === "view"}
        />
      </div>
      <div>
        <PickerSelectSimple
          dataSource={async (c) => {
            return [
              { label: "Symbolic", value: "Symbolic" },
              { label: "Physical", value: "Physical" },
            ];
          }}
          defaultSelected={
            form.getField("possession_type") !== ""
              ? [form.getField("possession_type")]
              : []
          }
          labelBaseProps={{
            label: "Possession Type",
          }}
          onChange={(value: any) => form.setField("possession_type", value)}
          error={
            form.errors.get("possession_type") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("possession_type")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableClear={false}
          enableClose={false}
          enableSearch={false}
          disabled={props.mode === "view"}
        />
      </div>
      <div className="col-span-2">
        <PickerSelectSimple
          dataSource={async (c) => {
            return [
              { label: "KYC by auctionbazaar.com", value: "DSC" },
              {
                label:
                  "Physical KYC required - To be submitted by client physically at Bank",
                value:
                  "Physical KYC required - To be submitted by client physically at Bank",
              },
            ];
          }}
          defaultSelected={
            form.getField("kyc_type") !== "" ? [form.getField("kyc_type")] : []
          }
          labelBaseProps={{
            label: "KYC Type",
          }}
          onChange={(value: any) => form.setField("kyc_type", value)}
          error={
            form.errors.get("kyc_type") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("kyc_type")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableClear={false}
          enableClose={false}
          enableSearch={false}
          disabled={props.mode === "view"}
        />
      </div>

      <div className="col-span-2 border-b border-gray-400 font-semibold pb-2 pt-8">
        Property Details
      </div>
      <div>
        <PickerSelectSimple
          refresh={currentBranch}
          dataSource={async (query: any) => {
            return await getPropertiesData(query);
          }}
          defaultSelected={
            form.getField("property_uuid") !== ""
              ? [form.getField("property_uuid")]
              : []
          }
          labelBaseProps={{
            label: "Property ID",
          }}
          onChange={(value: any) => {
            console.log("chec khere value", value);
            form.setField("property_uuid", value);
          }}
          error={
            form.errors.get("property_uuid") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("property_uuid")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableSearch={true}
          enableClear={false}
          enableClose={false}
          disabled={props.mode === "view"}
        />
      </div>
      <div>
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Property State",
          }}
          name={"property_state"}
          onChange={(val) => {}}
          type={"text"}
          value={form.value.property_uuid.property?.state.name}
          disabled={true}
          htmlFor={"property_state"}
        />
      </div>
      <div className="col-span-2">
        <TextAreaBase
          name={"property_address"}
          labelBaseProps={{
            label: "Property Address",
          }}
          rows={2}
          onChange={(val) => {}}
          value={form.value.property_uuid.property?.address}
          disabled={true}
        />
      </div>
      <div>
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Reserve Price",
          }}
          name={"reserve_price"}
          onChange={(val) => {}}
          type={"text"}
          value={form.value.property_uuid.property?.reserve_price}
          disabled={true}
          htmlFor={"reserve_price"}
        />
      </div>
      <div>
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "EMD Price",
          }}
          name={"emd_amount"}
          onChange={(val) => {}}
          type={"text"}
          value={form.value.property_uuid.property?.emd_amount}
          disabled={true}
          htmlFor={"emd_amount"}
        />
      </div>
      <div>
        <TextAreaBase
          name={"reserve_price"}
          labelBaseProps={{
            label: "Reserve Price in Words",
          }}
          rows={2}
          onChange={(val) => {}}
          value={convertAmmountToWords(
            form.value.property_uuid.property?.reserve_price,
          )}
          disabled={true}
        />
      </div>
      <div>
        <TextAreaBase
          name={"emd_amount"}
          labelBaseProps={{
            label: "EMD Price in Words",
          }}
          rows={2}
          onChange={(val) => {}}
          value={convertAmmountToWords(
            form.value.property_uuid.property?.emd_amount,
          )}
          disabled={true}
        />
      </div>
      <div>
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "EMD Last Date and Time (IST)",
          }}
          name={"emd_last_date"}
          onChange={(val) => {}}
          type={"text"}
          value={DateTime.fromISO(
            form.value.property_uuid.property?.emd_last_date,
          )
            .setZone("Asia/Kolkata")
            .toFormat("MMM dd, yyyy, hh:mm a")}
          disabled={true}
          htmlFor={"emd_last_date"}
        />
      </div>
      <div>
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Auction Start Date and Time (IST)",
          }}
          name={"auction_start_date_time"}
          onChange={(val) => {}}
          type={"text"}
          value={DateTime.fromISO(
            form.value.property_uuid.property?.auction_start_date_time,
          )
            .setZone("Asia/Kolkata")
            .toFormat("MMM dd, yyyy, hh:mm a")}
          disabled={true}
          htmlFor={"auction_start_date_time"}
        />
      </div>
      <div>
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Auction End Date and Time (IST)",
          }}
          name={"auction_end_date_time"}
          onChange={(val) => {}}
          type={"text"}
          value={DateTime.fromISO(
            form.value.property_uuid.property?.auction_end_date_time,
          )
            .setZone("Asia/Kolkata")
            .toFormat("MMM dd, yyyy, hh:mm a")}
          disabled={true}
          htmlFor={"auction_end_date_time"}
        />
      </div>
      <div>
        <PickerSelectSimple
          dataSource={async (query: any) => {
            return [
              { label: "Yes", value: "Yes" },
              { label: "No", value: "No" },
            ];
          }}
          defaultSelected={
            form.getField("auto_extension") !== ""
              ? [form.getField("auto_extension")]
              : [{ label: "Yes", value: "Yes" }]
          }
          labelBaseProps={{
            label: "Auto Extension",
          }}
          onChange={(value: any) => form.setField("auto_extension", value)}
          error={
            form.errors.get("auto_extension") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("auto_extension")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableSearch={false}
          enableClear={false}
          enableClose={false}
          disabled={props.mode === "view"}
        />
      </div>
      <div>
        <PickerSelectSimple
          dataSource={async (query: any) => {
            return [
              { label: "Unlimited", value: "Unlimited" },
              { label: "Limited", value: "Limited" },
            ];
          }}
          defaultSelected={
            form.getField("auto_extension_type") !== ""
              ? [form.getField("auto_extension_type")]
              : []
          }
          labelBaseProps={{
            label: "Auto Extension Type",
          }}
          onChange={(value: any) => form.setField("auto_extension_type", value)}
          error={
            form.errors.get("auto_extension_type") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("auto_extension_type")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableSearch={false}
          enableClear={false}
          enableClose={false}
          disabled={props.mode === "view"}
        />
      </div>
      <div>
        <PickerSelectSimple
          dataSource={async (query: any) => {
            return [
              { label: "With Current Time", value: "with_current_time" },
              { label: "With Final Time", value: "with_final_time" },
            ];
          }}
          defaultSelected={
            form.getField("extension_method") !== ""
              ? [form.getField("extension_method")]
              : []
          }
          labelBaseProps={{
            label: "Extension Method",
          }}
          onChange={(value: any) => form.setField("extension_method", value)}
          error={
            form.errors.get("extension_method") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("extension_method")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableSearch={false}
          enableClear={false}
          enableClose={false}
          disabled={props.mode === "view"}
        />
      </div>
      {form.value.auto_extension_type.value === "Limited" && (
        <div>
          <TextInputBase
            autoComplete="off"
            labelBaseProps={{
              label: "Auto Extension Limited by (Minutes)",
            }}
            name={"auto_extension_limit"}
            onChange={(val) => {
              form.setField("auto_extension_limit", val);
            }}
            placeholder={"Enter auto extension limit"}
            type={"number"}
            error={
              form.errors.get("auto_extension_limit") ? (
                <p className="mt-2 text-sm text-red-500">
                  {form.errors.get("auto_extension_limit")[0]}
                </p>
              ) : null
            }
            value={form.getField("auto_extension_limit")}
            htmlFor={"auto_extension_limit"}
            disabled={props.mode === "view"}
          />
        </div>
      )}
      <div>
        <PickerSelectSimple
          dataSource={async (query: any) => {
            return [
              { label: "5 Minutes", value: "5" },
              { label: "10 Minutes", value: "10" },
              { label: "15 Minutes", value: "15" },
            ];
          }}
          defaultSelected={
            form.getField("extend_time_at") !== ""
              ? [form.getField("extend_time_at")]
              : []
          }
          labelBaseProps={{
            label: "Extend time when valid bids received in last",
          }}
          onChange={(value: any) => form.setField("extend_time_at", value)}
          error={
            form.errors.get("extend_time_at") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("extend_time_at")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableSearch={false}
          enableClear={false}
          enableClose={false}
          disabled={props.mode === "view"}
        />
      </div>
      <div>
        <PickerSelectSimple
          dataSource={async (query: any) => {
            return [
              { label: "5 Minutes", value: "5" },
              { label: "10 Minutes", value: "10" },
              { label: "15 Minutes", value: "15" },
            ];
          }}
          defaultSelected={
            form.getField("extend_time_by") !== ""
              ? [form.getField("extend_time_by")]
              : []
          }
          labelBaseProps={{
            label: "Extend time by",
          }}
          onChange={(value: any) => form.setField("extend_time_by", value)}
          error={
            form.errors.get("extend_time_by") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("extend_time_by")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableSearch={false}
          enableClear={false}
          enableClose={false}
          disabled={props.mode === "view"}
        />
      </div>
      <div>
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Bidding Increment in Multiple of",
          }}
          name={"bidding_increment_amount"}
          onChange={(val) => {
            form.setField("bidding_increment_amount", val);
          }}
          placeholder={"Enter increment amount"}
          type={"text"}
          error={
            form.errors.get("bidding_increment_amount") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("bidding_increment_amount")[0]}
              </p>
            ) : null
          }
          value={form.getField("bidding_increment_amount")}
          htmlFor={"bidding_increment_amount"}
          disabled={props.mode === "view"}
        />
      </div>
      <div className="col-span-2">
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Bidding Increment in Multiple of (in Words)",
          }}
          name={"bidding_increment_amount_word"}
          onChange={(val) => {}}
          placeholder={"Enter increment amount"}
          type={"text"}
          value={amountInWords(form.value.bidding_increment_amount)}
          htmlFor={"bidding_increment_amount_word"}
          disabled={true}
        />
      </div>

      <div className="col-span-2 border-b border-gray-400 font-semibold pb-2 pt-8">
        Other Details
      </div>
      <div>
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Borrower Name",
          }}
          name={"borrower_name"}
          onChange={(val) => {
            form.setField("borrower_name", val);
          }}
          placeholder={"Enter borrower name"}
          type={"text"}
          error={
            form.errors.get("borrower_name") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("borrower_name")[0]}
              </p>
            ) : null
          }
          value={form.getField("borrower_name")}
          htmlFor={"borrower_name"}
          disabled={props.mode === "view"}
        />
      </div>
      <div>
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Inspection of asset from Date and Time",
          }}
          name={"inspection_from_time"}
          onChange={(val) => {}}
          type={"text"}
          value={
            form.value.property_uuid.property?.physical_inspection_timeline
          }
          disabled={true}
          htmlFor={"inspection_from_time"}
        />
      </div>
      <div>
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Inspection of asset to Date and Time",
          }}
          name={"inspection_to_time"}
          onChange={(val) => {}}
          type={"text"}
          value={
            form.value.property_uuid.property?.physical_inspection_timeline
          }
          disabled={true}
          htmlFor={"inspection_to_time"}
        />
      </div>
      <div>
        <TextAreaBase
          name={"inspection_ofc_contact"}
          labelBaseProps={{
            label: "Inspection Officer Contact Details",
          }}
          rows={2}
          onChange={(val) => {}}
          value={form.value.property_uuid.property?.contact}
          disabled={true}
        />
      </div>
      <div className="col-span-2">
        <TextAreaBase
          placeholder="Enter remark"
          name={"comment"}
          labelBaseProps={{
            label: "Remark",
          }}
          rows={3}
          onChange={(val) => {
            form.setField("comment", val);
          }}
          value={form.getField("comment")}
          error={
            form.errors.get("comment") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("comment")[0]}
              </p>
            ) : null
          }
          disabled={props.mode === "view"}
        />
      </div>

      <div className="col-span-2 border-b border-gray-400 font-semibold pb-2 pt-8">
        EMD Payment Account Details
      </div>
      <div>
        <TextAreaBase
          labelBaseProps={{
            label: "Account Name",
          }}
          name={"emd_payment_account_name"}
          onChange={(val) => {
            form.setField("emd_payment_account_name", val);
          }}
          placeholder={"Enter account name"}
          rows={2}
          error={
            form.errors.get("emd_payment_account_name") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("emd_payment_account_name")[0]}
              </p>
            ) : null
          }
          value={form.getField("emd_payment_account_name")}
          disabled={props.mode === "view"}
        />
        {/* <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Account Name",
          }}
          name={"emd_payment_account_name"}
          onChange={(val) => {
            form.setField("emd_payment_account_name", val);
          }}
          placeholder={"Enter account name"}
          type={"text"}
          error={
            form.errors.get("emd_payment_account_name") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("emd_payment_account_name")[0]}
              </p>
            ) : null
          }
          value={form.getField("emd_payment_account_name")}
          htmlFor={"emd_payment_account_name"}
          disabled={props.mode === "view"}
        /> */}
      </div>
      <div>
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Account Number",
          }}
          name={"emd_payment_account_number"}
          onChange={(val) => {
            form.setField("emd_payment_account_number", val);
          }}
          placeholder={"Enter account number"}
          type={"text"}
          error={
            form.errors.get("emd_payment_account_number") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("emd_payment_account_number")[0]}
              </p>
            ) : null
          }
          value={form.getField("emd_payment_account_number")}
          htmlFor={"emd_payment_account_number"}
          disabled={props.mode === "view"}
        />
      </div>
      <div>
        <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "IFSC Code",
          }}
          name={"emd_payment_account_ifsc"}
          onChange={(val) => handleIFSCCode(val)}
          placeholder={"Enter account IFSC code"}
          type={"text"}
          error={
            form.errors.get("emd_payment_account_ifsc") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("emd_payment_account_ifsc")[0]}
              </p>
            ) : null
          }
          value={form.getField("emd_payment_account_ifsc")}
          htmlFor={"emd_payment_account_ifsc"}
          disabled={props.mode === "view"}
        />
      </div>
      <div>
        <TextAreaBase
          labelBaseProps={{
            label: "Bank Name",
          }}
          name={"emd_payment_account_bank"}
          onChange={(val) => {
            form.setField("emd_payment_account_bank", val);
          }}
          placeholder={"Enter bank name"}
          rows={2}
          error={
            form.errors.get("emd_payment_account_bank") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("emd_payment_account_bank")[0]}
              </p>
            ) : null
          }
          value={form.getField("emd_payment_account_bank")}
          disabled={props.mode === "view"}
        />
        {/* <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Bank Name",
          }}
          name={"emd_payment_account_bank"}
          onChange={(val) => {
            form.setField("emd_payment_account_bank", val);
          }}
          placeholder={"Enter bank name"}
          type={"text"}
          error={
            form.errors.get("emd_payment_account_bank") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("emd_payment_account_bank")[0]}
              </p>
            ) : null
          }
          value={form.getField("emd_payment_account_bank")}
          htmlFor={"emd_payment_account_bank"}
          disabled={props.mode === "view"}
        /> */}
      </div>
      <div>
        <TextAreaBase
          labelBaseProps={{
            label: "Branch Name",
          }}
          name={"emd_payment_account_branch"}
          onChange={(val) => {
            form.setField("emd_payment_account_branch", val);
          }}
          placeholder={"Enter branch name"}
          rows={2}
          error={
            form.errors.get("emd_payment_account_branch") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("emd_payment_account_branch")[0]}
              </p>
            ) : null
          }
          value={form.getField("emd_payment_account_branch")}
          disabled={props.mode === "view"}
        />
        {/* <TextInputBase
          autoComplete="off"
          labelBaseProps={{
            label: "Branch Name",
          }}
          name={"emd_payment_account_branch"}
          onChange={(val) => {
            form.setField("emd_payment_account_branch", val);
          }}
          placeholder={"Enter branch name"}
          type={"text"}
          error={
            form.errors.get("emd_payment_account_branch") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("emd_payment_account_branch")[0]}
              </p>
            ) : null
          }
          value={form.getField("emd_payment_account_branch")}
          htmlFor={"emd_payment_account_branch"}
          disabled={props.mode === "view"}
        /> */}
      </div>
      <div>
        <PickerSelectSimple
          dataSource={async (query: any) => {
            return [
              { label: "Online - NEFT/RTGS", value: "Online - NEFT/RTGS" },
              {
                label: "Offline payment at Bank",
                value: "Offline payment at Bank",
              },
            ];
          }}
          defaultSelected={
            form.getField("emd_payment_method") !== ""
              ? [form.getField("emd_payment_method")]
              : []
          }
          labelBaseProps={{
            label: "EMD Payment Method",
          }}
          onChange={(value: any) => form.setField("emd_payment_method", value)}
          error={
            form.errors.get("emd_payment_method") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("emd_payment_method")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableSearch={false}
          enableClear={false}
          enableClose={false}
          disabled={props.mode === "view"}
        />
      </div>
      <div>
        <PickerSelectSimple
          dataSource={async (c) => {
            return [
              { label: "With Reserve Price", value: "rp" },
              {
                label: "With Increment Price",
                value: "ib",
              },
            ];
          }}
          defaultSelected={
            form.getField("bidding_type") !== ""
              ? [form.getField("bidding_type")]
              : []
          }
          labelBaseProps={{
            label: "Bidding Type",
          }}
          onChange={(value: any) => form.setField("bidding_type", value)}
          error={
            form.errors.get("bidding_type") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("bidding_type")[0]}
              </p>
            ) : null
          }
          valueKey="value"
          multiple={false}
          enableClear={false}
          enableClose={false}
          enableSearch={false}
          disabled={props.mode === "view"}
        />
      </div>

      {props.mode !== "view" &&
        (!props.prefillData ||
          ["pending", "accepted", "rejected"].includes(
            props.prefillData?.status,
          )) && (
          <div className="text-center sm:text-left pt-2 col-span-2">
            <ButtonBase
              variant="primary"
              type="submit"
              label={"Submit"}
              onClick={() => handleSubmit()}
              buttonBaseClasses={{
                font: "text-base font-medium",
                backgroundColor: "bg-blue-600 hover:bg-blue-700",
                textColor: "text-white",
                border: "any",
                width: "w-24",
                padding: "px-4 py-2",
              }}
              busy={form.busy}
              busyText={<Loader height="h-6" width="w-6" />}
            />
          </div>
        )}
      {props.mode === "view" &&
        props.prefillData?.approver === userProfile.uuid &&
        props.prefillData?.status === "pending" && (
          <div className="flex justify-between text-center pt-2 col-span-2">
            <ButtonBase
              variant="primary"
              type="button"
              label={"Accept"}
              onClick={() => handleApproval()}
              buttonBaseClasses={{
                font: "text-base font-medium",
                backgroundColor: "bg-green-600 hover:bg-green-700",
                textColor: "text-white",
                border: "any",
                width: "w-24",
                padding: "px-4 py-2",
              }}
              busy={form.busy}
              busyText={<Loader height="h-6" width="w-6" />}
            />
            <ButtonBase
              variant="primary"
              type="button"
              label={"Reject"}
              onClick={() =>
                openModal(
                  "rejected",
                  "Rejecting Auction Event",
                  "Are you sure you wants to reject the Auction event, Please add remark/comment",
                  "bg-red-50 text-red-500",
                  "",
                )
              }
              buttonBaseClasses={{
                font: "text-base font-medium",
                backgroundColor: "bg-red-600 hover:bg-red-700",
                textColor: "text-white",
                border: "any",
                width: "w-24",
                padding: "px-4 py-2",
              }}
              busy={form.busy}
              busyText={<Loader height="h-6" width="w-6" />}
            />
          </div>
        )}
    </div>
  );
}
